module.exports = __webpack_public_path__ + "05_long_brown.f6fb2f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/05_long_brown.png
// module id = rD82
// module chunks = 0